module.exports = __webpack_public_path__ + "static/media/SARA KELLAWI.be20db70.png";